var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.visible}},[_c('v-btn',{staticClass:"ms-2",attrs:{"small":"","icon":"","color":"white"},on:{"click":_vm.close}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-close ")])],1),_c('v-img',{attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }